import './styles/quasar.scss';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/material-icons-round/material-icons-round.css';
import '@quasar/extras/material-icons-sharp/material-icons-sharp.css';
import Notify from 'quasar/src/plugins/Notify.js';import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';import Cookies from 'quasar/src/plugins/Cookies.js';;

// To be used on app.use(Quasar, { ... })
export const quasarConfig = {
  css: ['index.css'],
  config: {},
  plugins: {
    Notify,
    LocalStorage,
    SessionStorage,
    Cookies,
  },
};
